import { gql } from "@apollo/client";

export const createPromotion = gql`
mutation CreatePromotion($input: PromotionInput) {
  createPromotion(input: $input) {
    id
  }
}
`

export const updatePromotion = gql`
mutation UpdatePromotion($input: UpdatePromotionInput) {
  updatePromotion(input: $input) {
    id
  }
}
`

export const updatePromotionStatus = gql`
mutation UpdatePromotionStatus($input: UpdatePromotionStatusInput) {
  updatePromotionStatus(input: $input)
}
`

export const deletePromotion = gql`
mutation DeletePromotion($input: DeletePromotionInput) {
  deletePromotion(input: $input)
}
`;